import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from "../../config/httpConfig"


export const getAllEscrowDetails = createAsyncThunk(
    "wallets/getAllEscrowDetails",
    async () => {
        const response = await axios.get(
            `/api/business/getAllEscrowDetails`
        );
        return response.response;
    }
)
export const verifyIfsc = createAsyncThunk(
    "wallets/verifyIfsc",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/business/verifyIfsc', payload);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)


export const withdraw = createAsyncThunk(
    "wallets/withdraw",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `/api/business/withdraw`, payload
            );
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const sendWithdrawOtp = createAsyncThunk(
    "wallets/sendWithdrawOtp",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`/api/business/withdraw/sendOtp`);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


export const verifyBank = createAsyncThunk(
    "wallets/verifyBank",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/business/addSecondaryBank', payload);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)
export const internalTransfer = createAsyncThunk(
    "wallets/internalTransfer",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/business/internalTransfer', payload);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const sendDepositDetails = createAsyncThunk(
    "wallets/sendDepositDetails",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/api/business/sendDepositDetails",
                payload
            );
            return response;
        } catch (err) {
            return rejectWithValue(err || "An error occurred");
        }
    }
);

export const getAccountTxnHistory = createAsyncThunk(
    "manageFunds/getAccountTxnHistory",
    async (params, { rejectWithValue }) => {
        const { withdraw, deposit, internalTransfer, dealRepayment } = params;
        try {
            const response = await axios.get(
                `/api/business/getAccountTxnHistory?withdraw=${withdraw}&deposit=${deposit}&internalTransfer=${internalTransfer}&dealRepayment=${dealRepayment}`
            );
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);



export const walletsSlice = createSlice({
    name: 'wallets',
    initialState: {
        loading: false,
        status: [],
        wallet: [],
        ifscdets: {},
        karncyWallet: [],
        platformWallet: [],
        walletDetailedView: [],
        error: '',
        withdrawLoading: false,
        withdrawError: null,
        withdrawOtpLoading: false,
        withdrawOtpError: null,
        withdrawOtpData: null,
        txnHistoryData: [],
        txnHisLoading: false
    },

    extraReducers: (builder) => {
        builder.addCase(getAllEscrowDetails.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(getAllEscrowDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.wallet = action.payload;

        });
        builder.addCase(getAllEscrowDetails.rejected, (state, action) => {
            state.loading = false;
            state.wallet = [];
            state.error = action.payload;
        });


        builder.addCase(verifyIfsc.pending, (state) => {
            state.error = '';
        });
        builder.addCase(verifyIfsc.fulfilled, (state, action) => {
            state.ifscdets = action.payload;
            state.error = "";

        });
        builder.addCase(verifyIfsc.rejected, (state, action) => {
            state.ifscdets = {};
            state.error = action.payload;
        });


        builder
            .addCase(withdraw.pending, (state) => {
                state.withdrawLoading = true;
                state.withdrawError = null;
            })
            .addCase(withdraw.fulfilled, (state) => {
                state.withdrawLoading = false;
            })
            .addCase(withdraw.rejected, (state, action) => {
                state.withdrawLoading = false;
                state.withdrawError = action.payload;
            });

        builder
            .addCase(sendWithdrawOtp.pending, (state) => {
                state.withdrawOtpLoading = true;
                state.withdrawOtpError = null;
            })
            .addCase(sendWithdrawOtp.fulfilled, (state, action) => {
                state.withdrawOtpLoading = false;
                state.withdrawOtpError = null;
                state.withdrawOtpData = action.payload?.response || action.payload || null;
            })
            .addCase(sendWithdrawOtp.rejected, (state, action) => {
                state.withdrawOtpLoading = false;
                state.withdrawOtpError = action.payload;
                state.withdrawOtpData = null;
            });

        builder.addCase(verifyBank.pending, (state) => {
            state.loading = true
            state.error = "";
        });
        builder.addCase(verifyBank.fulfilled, (state, action) => {
            state.loading = false
            state.error = "";
        });
        builder.addCase(verifyBank.rejected, (state, action) => {
            state.loading = false
            state.error = action.payload;
        });
        builder.addCase(internalTransfer.pending, (state) => {
            state.transferSubmitLoading = true
            state.error = "";
        });
        builder.addCase(internalTransfer.fulfilled, (state, action) => {
            state.transferSubmitLoading = false
            state.error = "";
        });
        builder.addCase(internalTransfer.rejected, (state, action) => {
            state.transferSubmitLoading = false
            state.error = action.payload;
        });

        builder.addCase(getAccountTxnHistory.pending, (state) => {
            state.txnHisLoading = true;
            state.error = null;
        });
        builder.addCase(getAccountTxnHistory.fulfilled, (state, action) => {
            state.txnHisLoading = false;
            state.txnHistoryData = action.payload;
            state.error = null;
        });
        builder.addCase(getAccountTxnHistory.rejected, (state, action) => {
            state.txnHisLoading = false;
            state.txnHistoryData = [];
            state.error = action.payload;
        });


    },

    reducers: {
        updateErrorStatus(state, action) {
            state.error = null;
        },
        clearWithdrawOtpState(state) {
            state.withdrawOtpLoading = false;
            state.withdrawOtpError = null;
            state.withdrawOtpData = null;
        },
    }



})

export const { updateErrorStatus, clearWithdrawOtpState } = walletsSlice.actions

export default walletsSlice.reducer